import React from "react";
import "../static/style/about.css";
import mypic from "../static/images/mypic.jpg";
import img from '../static/images/about.png'

function About() {
  return (
    <div className="about">
      <div className="head">
        <h2>About Me</h2>
      </div>
      <div className="inner">
        <div className="wrapper2">
          {/*
          <div className="img">
            
           <img src={img} class="mupic" loading="lazy" />
            <div className="back"></div>
          </div>
            */}
            <img src={img}/>
        </div>
        <p>
          Hi there, my name is Merwan Bekkar and I am a passionate computer
          science student and full-stack web developer. I am currently studying
          at the National School of Computer Science (ESI ex.INI) and have more
          than two years of experience in web development. I enjoy working with
          React, Django, Python, JavaScript, HTML, and CSS to create dynamic and
          responsive web applications. In addition to web development, I have a
          strong interest in cybersecurity and am currently learning about data
          science and machine learning. I believe that these fields will play an
          increasingly important role in the future, and I am excited to be a
          part of it. As a developer, I am dedicated to writing clean and
          efficient code and enjoy solving complex problems. I am always looking
          for ways to improve my skills and stay up-to-date with the latest
          technologies. When I'm not coding, you can usually find me reading
          about technology or exploring new programming languages. Overall, I am
          passionate about technology and am committed to pursuing a career in
          the field. I am excited to see what the future holds and look forward
          to making a meaningful contribution to the industry.
        </p>
      </div>
    </div>
  );
}

export default About;
